import { createContext } from 'react';

/** The slot at the foot of the content panel, below its scrolling area. */
export const PageFooterContext = createContext<HTMLElement | null>(null);
